<template>
  <div class="speaker">
    <video ref="myvideo" src="" loop type="video/mp4" preload="metadata" muted></video>
    <!-- 画布元素 -->
    <canvas willReadFrequently="true" ref="canvas"></canvas>
  </div>
</template>

<script>
import Broadcast from './broadcast.js' // 文字播报

export default {
  name: 'speaker',
  data() {
    return {
      broadcast: null,
      featherStrength: 0.8 // 人物羽化强度
    }
  },
  computed: {
   
  },
  watch: {
    
  },
  created() {
    // 文字播报
    this.broadcast = new Broadcast()
    
    this.broadcast.audioPlayer.onPlay = () => {
      console.log('监听开始播报')
      this.video.src = this.$storeCase.figureConfig.video_output
      this.video.currentTime = 0
      this.video.play()
    }
    this.broadcast.audioPlayer.onStop = (e) => {
      console.log('监听结束播报')
      this.Interrupt()
    }
  },
  mounted() {
    this.video = this.$refs.myvideo
    this.canvas = this.$refs.canvas
    this.ctx = this.canvas.getContext('2d')
    this.canvas_tmp = document.createElement('canvas')
    this.canvas_tmp.width = this.video.clientWidth
    this.canvas_tmp.height = this.video.clientHeight
    this.canvas.width = this.video.clientWidth
    this.canvas.height = this.video.clientHeight
    this.ctx_tmp = this.canvas_tmp.getContext('2d')
    this.video.addEventListener('play', this.computeFrame)
    this.video.addEventListener('canplaythrough', () => {
      this.$emit('loaded')
    })
    this.init()
  },
  destroyed () {
    this.broadcast.audioPlayer.stop()
  },
  methods: {
    init() {
      let str = sessionStorage.getItem('zntParam')
      if(str){
        this.$storeCase.initFigure(JSON.parse(str))
      } else {
        this.$storeCase.initFigure({
          six: '女',
          index: 1
        })
      }
      this.Interrupt()
    },
    
    // 文本播报
    playWelcome(text){
      if(text){
        this.broadcast?.play({
          text: text,
          vcn: window.broadcastConfig.dub
        })
      }
    },
    
    // 打断播报
    Interrupt(){
      if(this.video?.src){
        this.video?.pause()
      }
      this.video.src = this.$storeCase.figureConfig.video_stationary
      this.video.currentTime = 0
      this.video?.play()
    },
    
    numToPoint (num, width) {
      let col = num % width
      let row = Math.floor(num / width)
      row = col === 0 ? row : row + 1
      col = col === 0 ? width : col
      return [row, col]
    },
 
    pointToNum (point, width) {
      let [row, col] = point
      return (row - 1) * width + col
    },
 
    getAroundPoint (point, width, height, area) {
      let [row, col] = point;
      let allAround = [];
      if (row > height || col > width || row < 0 || col < 0) return allAround;
      for (let i = 0; i < area; i++) {
        let pRow = row - 1 + i;
        for (let j = 0; j < area; j++) {
          let pCol = col - 1 + j;
          if (i === area % 2 && j === area % 2) continue;
          allAround.push([pRow, pCol]);
        }
      }
      return allAround.filter(([iRow, iCol]) => {
        return iRow > 0 && iCol > 0 && iRow <= height && iCol <= width;
      });
    },
 
    computeFrame () {
      if (this.video) {
        if (this.video.paused || this.video.ended) return;
      }
      this.ctx_tmp.drawImage(this.video, 0, 0, this.video.clientWidth, this.video.clientHeight);
 
      let frame = this.ctx_tmp.getImageData(0, 0, this.video.clientWidth, this.video.clientHeight);
 
      const height = frame.height;
      const width = frame.width;
      const pointLens = frame.data.length / 4;
 
      // 背景透明化（假设背景为特定颜色，这里选择绿色）
      for (let i = 0; i < pointLens; i++) {
        let r = frame.data[i * 4];
        let g = frame.data[i * 4 + 1];
        let b = frame.data[i * 4 + 2];
        if (r < 100 && g > 120 && b < 200) {
          frame.data[i * 4 + 3] = 0;
        }
      }
 
      const tempData = [...frame.data];
      for (let i = 0; i < pointLens; i++) {
        if (frame.data[i * 4 + 3] === 0) continue;
        const currentPoint = this.numToPoint(i + 1, width);
        const arroundPoint = this.getAroundPoint(currentPoint, width, height, 3);
 
        let opNum = 0;
        let rSum = 0;
        let gSum = 0;
        let bSum = 0;
        arroundPoint.forEach((position) => {
          const index = this.pointToNum(position, width);
          rSum += tempData[(index - 1) * 4];
          gSum += tempData[(index - 1) * 4 + 1];
          bSum += tempData[(index - 1) * 4 + 2];
          if (tempData[(index - 1) * 4 + 3] !== 255) opNum++;
        });
 
        let alpha = (255 / arroundPoint.length) * (arroundPoint.length - opNum);
 
        // 调整羽化效果
        if (alpha !== 255) {
          frame.data[i * 4] = parseInt(rSum / arroundPoint.length);
          frame.data[i * 4 + 1] = parseInt(gSum / arroundPoint.length);
          frame.data[i * 4 + 2] = parseInt(bSum / arroundPoint.length);
 
          // 根据羽化强度调整 alpha
          frame.data[i * 4 + 3] = parseInt(alpha * this.featherStrength);
        }
      }
 
      this.ctx.putImageData(frame, 0, 0);
      setTimeout(this.computeFrame, 0);
    }
  }
}
</script>

<style lang="less" scoped>
  .speaker {
    width: 200px;
    height: 600px;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    pointer-events: none;
    
    video {
      width: 90%;
      height: 90%;
      border: 0;
      padding: 0;
      display: block;
      object-fit: contain;
      position: absolute;
      top: -100%;
      left: 10%;
    }
    
    canvas{
      width: 90%;
      height: 90%;
      position: absolute;
      left: 5%;
      top: 10%;
      object-fit: contain;
      // filter: drop-shadow(0 0 15px #fff);
    }
  }
</style>